import React, { useState, useEffect } from 'react';
import ModalShowCourse from './ModalShowCourse';
import { NumericFormat } from 'react-number-format';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';

const PublicationShow = (props) => {
    const [modal, setModal] = useState(false);
    const [course, setCourse] = useState({});

    const toogle = (course) => {        
        if(modal){
            setCourse({})
            setModal(false);
        }else{
            setCourse(course)
            setModal(true)
        }
    }

    return (
        <React.Fragment>
            {modal && (
                <ModalShowCourse
                    //modal props
                    backdrop={"static"}
                    modal={modal}
                    toggle={toogle}
                    course={course}
                />
            )}

            <div className="card mt-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md 12">
                            <h3 className='mb-0 text-primary'>{props.publicacion.name}</h3>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12">
                            <p className='text-dark'>{props.publicacion.description}</p>
                        </div>

                        {isMobile && (
                            <div className="col-md-12">
                                <button 
                                    className='btn btn-primary btn-lg btn-block' 
                                    onClick={() => props.current_user.user_logged_in ? props.toogleTabUser("payment") : props.toogleTab("user_info")}
                                > 
                                    Pagar 
                                </button>
                            </div>
                        )}

                        {props.publicacion.benefits.length >= 1 && (
                            <React.Fragment>
                                <div className="col-md-12">
                                    <hr />
                                </div>

                                <div className="col-md-12 mb-2">
                                    <h3 className='text-primary'>Beneficios</h3>
                                </div>

                                <div className="col-md-12">
                                    <ul>
                                        {props.publicacion.benefits.map(benefit => (
                                            <li className='text-dark'> - {benefit}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="col-md-12">
                                    <hr />
                                </div>
                            </React.Fragment>
                        )}

                        {props.publicacion.affiliate && (
                            <React.Fragment>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <img src={props.affiliate.image} className='img-thumbnail' alt="" />
                                        </div>

                                        <div className="col-md-9">
                                            <h4 className='mb-0 text-primary'>{props.affiliate.name}</h4>
                                            {ReactHtmlParser(props.affiliate.rating_start)}
                                            <p className='text-dark mt-1'>{props.affiliate.description}</p>
                                        </div>
                                    </div>
                                </div>   

                                <div className="col-md-12">
                                    <hr />
                                </div>
                            </React.Fragment>
                        )}

                        {props.publicacion.courses.length >= 1 && (
                            <React.Fragment>
                                <div className="col-md-12 mb-2">
                                    <h3 className='text-primary'>Cursos que añade esta campaña</h3>
                                </div>


                                <div className="table-responsive">
                                    <table className="table table-responsive-sm">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className='text-primary'>Nombre</th>
                                                <th className='text-primary'>Precio</th>
                                                <th className='text-primary' style={{ width: 93 }}>Ver curso</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {props.publicacion.courses.map(course => (
                                                <tr key={course.id}>
                                                    <td><img width="128" src={course.image.url} className="img-fluid"  /></td>
                                                    <td className='text-dark'>{course.name}</td>
                                                    <td>
                                                        {typeof course.price == "string" ? course.price : <NumericFormat displayType={"text"} thousandSeparator={true} prefix={'$'} value={course.price} />}
                                                    </td>
                                                    <td><button className='btn btn-primary' onClick={() => toogle(course)}>Ver</button></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}


export default PublicationShow;


/*


                                    <div className="row">
                                        {props.publicacion.courses.map(course => (
                                            <div className="col-md-4" key={course.id}>
                                                <div className="card">
                                                    <img src={course.image.url} className="img-fluid"  />
                                                    <div className="card-body">
                                                        <p>{course.name}</p>
                                                    </div>

                                                    <div className="card-footer">
                                                        <button className='btn btn-primary btn-block' onClick={() => toogle(course)}>Ver mas</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
*/